import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { EventVisibilityModeModel } from 'src/app/models/event-visibility-mode.model';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';
import { RoleModel } from 'src/app/models/person/role.model';
import { StandardTrainingCategoryViewModel } from 'src/app/models/standard-training-category/standard-training-category-view.model';
import { TenantSubscriberModel } from 'src/app/models/subscription/tenant-subscriber.model';
import { TrainingCategoryModel } from 'src/app/models/training-category/training-category.model';
import { TrainingGroupModel } from 'src/app/models/training-group.model';

@Component({
  selector: 'app-target-group-section',
  standalone: false,
  templateUrl: './target-group-section.component.html',
  styleUrl: './target-group-section.component.scss',
})
export class TargetGroupSectionComponent {
  @Input() isViewMode = false;
  @Input() isCourse = false;
  @Input() isPrivatePublishing = false;

  @Input() visibilityMode: EventVisibilityModeModel = 
    EventVisibilityModeModel.Everyone;

  @Input() selectedOrganizationUnitIds: string[] = [];

  @Input() organizationUnits: OrganisationUnitModel[] = [];
  @Input() trainingGroups: TrainingGroupModel[] = [];
  @Input() trainingCategories: TrainingCategoryModel[] = [];
  @Input() subscribers: TenantSubscriberModel[] = [];
  @Input() standardTrainingCategories: StandardTrainingCategoryViewModel[] = [];
  @Input() roles: RoleModel[] = [];
  @Input() usedStandardTrainingCategories: StandardTrainingCategoryViewModel[] = [];

  @Input() allowSharingWithSubscribers: boolean = false;
  @Input() trainingGroupIds: string[] = [];
  @Input() trainingCategoryIds: string[] = [];
  @Input() subscriptionIds: string[] = [];
  @Input() standardTrainingCategoryIds: string[] = [];
  @Input() roleIds: string[] = [];

  @Input() personCount = 0;

  @Output() visibilityModeChange = new EventEmitter<EventVisibilityModeModel>();
  @Output() selectedOrganizationUnitIdsChange = new EventEmitter<string[]>();
  @Output() trainingGroupIdsChange = new EventEmitter<string[]>();
  @Output() trainingCategoryIdsChange = new EventEmitter<string[]>();
  @Output() allowSharingWithSubscribersChange = new EventEmitter<boolean>();
  @Output() subscriptionIdsChange = new EventEmitter<string[]>();
  @Output() standardTrainingCategoryIdsChange = new EventEmitter<string[]>();
  @Output() roleIdsChange = new EventEmitter<string[]>();

  onVisibilityModeChanged(mode: EventVisibilityModeModel): void {
    this.visibilityMode = mode;
    this.visibilityModeChange.emit(mode);
  }

  onOrganizationUnitIdsChanged(ids: string[]): void {
    this.selectedOrganizationUnitIds = ids;
    this.selectedOrganizationUnitIdsChange.emit(ids);
  }

  onTrainingGroupIdsChanged(ids: string[]): void {
    this.trainingGroupIds = ids;
    this.trainingGroupIdsChange.emit(ids);
  }

  onTrainingCategoryIdsChanged(ids: string[]): void {
    this.trainingCategoryIds = ids;
    this.trainingCategoryIdsChange.emit(ids);
  }

  onSubscriptionIdsChanged(ids: string[]): void {
    this.subscriptionIds = ids;
    this.subscriptionIdsChange.emit(ids);
  }

  onStandardTrainingCategoryIdsChanged(ids: string[]): void {
    this.standardTrainingCategoryIds = ids;
    this.standardTrainingCategoryIdsChange.emit(ids);
  }
  
  onAllowSharingWithSubscribersChanged(value: boolean) {
    this.allowSharingWithSubscribers = value;
    this.allowSharingWithSubscribersChange.emit(value);
  }

  onRoleIdsChanged(ids: string[]): void {
    this.roleIds = ids;
    this.roleIdsChange.emit(ids);
  }
}
